module.exports = __webpack_public_path__ + "static/media/leb.b0087eb4.jpg";